'use client'

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import type { Media } from '@/payload-types'
import { getMediaUrl } from '@/utilities/getMediaUrl'

interface HeaderLogoProps {
  lightModeLogo?: Media | null
  darkModeLogo?: Media | null
  variant?: 'desktop' | 'mobile'
  disableLink?: boolean
  theme?: string | null
}

export const HeaderLogo: React.FC<HeaderLogoProps> = ({
  lightModeLogo,
  darkModeLogo,
  variant = 'desktop',
  disableLink = false,
  theme,
}) => {
  // Pick the correct logo asset based on theme
  const logo = theme === 'dark' ? (darkModeLogo ?? lightModeLogo) : (lightModeLogo ?? darkModeLogo)

  if (!logo?.url) return null

  const src = getMediaUrl(logo.url) || logo.url
  const alt = logo.alt || 'LYNX Permits'

  if (variant === 'mobile') {
    return (
      <div className="relative w-10 h-10 overflow-hidden">
        {disableLink ? (
          <Image fill src={src} alt={alt} sizes="40px" className="object-contain" />
        ) : (
          <Link href="/" className="relative block w-full h-full cursor-pointer">
            <Image fill src={src} alt={alt} sizes="40px" className="object-contain" />
          </Link>
        )}
      </div>
    )
  }

  if (disableLink) {
    return (
      <div className="w-20 lg:w-24">
        <Image
          src={src}
          alt={alt}
          width={logo.width || 96}
          height={logo.height || 34}
          className="w-full h-auto object-contain"
        />
      </div>
    )
  }

  return (
    <Link href="/" className="w-20 lg:w-24 cursor-pointer">
      <Image
        src={src}
        alt={alt}
        width={logo.width || 96}
        height={logo.height || 34}
        className="w-full h-auto object-contain"
        priority
      />
    </Link>
  )
}
